module.exports = __webpack_public_path__ + "img/vmp_ch_vlad_0.8fb5e847.png";